import React from 'react';
import {
  Page,
  View,
  Document,
  StyleSheet,
  Text,
  Image,
  Font
} from '@react-pdf/renderer';
import NotoSansJP from '../components/assets/fonts/NotoSansJP-Regular.otf';
import { Buffer } from 'buffer';

window.Buffer = Buffer;

Font.register({
  family: 'NotoSansJP',
  src: NotoSansJP,
});

console.log(NotoSansJP);

const styles = StyleSheet.create({
  page: {
    fontFamily: 'NotoSansJP',
    fontSize: 8,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  header: {
    width: '100%',
    marginBottom: 6,
  },
  columns: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    width: '100%',
  },
  column: {
    flex: 1,
    paddingHorizontal: 4,
    flexDirection: 'column',
    border: '1pt solid #bbb',
    borderRadius: 4,
  },
  sectionTitle: {
    fontSize: 12,
    marginBottom: 4,
  },
  categoryTitle: {
    fontSize: 10,
    marginTop: 4,
    marginBottom: 2,
  },
  paymentTitle: {
    fontSize: 9,
    marginTop: 2,
    marginBottom: 1,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
    borderBottom: '0.5pt solid #ccc',
    gap: 4,
  },
  image: {
    width: 20,
    height: 20,
  },
  text: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  name: {
    fontSize: 5,
    maxWidth: '65%',
    wordBreak: 'break-word',
  },
  price: {
    fontSize: 7,
    textAlign: 'right',
    color: '#000',
  },
});

const buildFlatItems = (title, dataByCategory, filterFn) => {
  const result = [];
  for (const [category, payments] of Object.entries(dataByCategory)) {
    if (filterFn && !filterFn(category)) continue;
    let addedCategory = false;

    for (const [method, items] of Object.entries(payments)) {
      const filtered = items.filter(i => i.product_name !== 'レジ袋');
      if (!filtered.length) continue;

      const total = filtered.reduce((sum, i) => sum + (i.subtotal || 0), 0);

      if (!addedCategory) {
        result.push({ type: 'category', text: `[${title}] ${category}` });
        addedCategory = true;
      }
      result.push({ type: 'payment', text: `支払方法: ${method}（¥${total.toLocaleString()}）` });

      for (const item of filtered) {
        result.push({
          type: 'item',
          sku: item.sku,
          inventory_id: item.inventory_id,
          product_name: item.product_name,
          unit_price: item.unit_price,
        });

        if (Array.isArray(item.set_items_details)) {
          for (const setItem of item.set_items_details) {
            result.push({
              type: 'set_item',
              sku: setItem.sku,
              inventory_id: setItem.id,
              product_name: `【セット】${setItem.item_name}`,
              unit_price: '',
            });
          }
        }
      }
    }
  }
  return result;
};
const renderBlock = (block, idx) => {
  console.log("PDF IMAGE SKU", block.sku);
  if (block.type === 'category') {
    return (
      <Text key={idx} style={styles.categoryTitle}>
        {block.text}
      </Text>
    );
  }

  if (block.type === 'payment') {
    return (
      <Text key={idx} style={styles.paymentTitle}>
        {block.text}
      </Text>
    );
  }

  const safeImageSrc =
    block?.sku &&
    block.sku !== "undefined" &&
    block.sku !== "null"
      ? `/media/product_images/${block.sku}.jpg`
      : null;

  return (
    <View style={styles.item} key={idx}>
      {safeImageSrc ? (
        <Image style={styles.image} src={safeImageSrc} />
      ) : (
        <View style={styles.image} />
      )}

      <View style={styles.text}>
        <Text style={styles.name}>
          ({block.inventory_id}) {block.product_name}
        </Text>

        <Text style={styles.price}>
          {block.unit_price !== '' ? `¥${block.unit_price}` : ''}
        </Text>
      </View>
    </View>
  );
};

const chunkIntoPages = (items, itemsPerCol = 28) => {
  const pages = [];
  for (let i = 0; i < items.length; i += itemsPerCol * 3) {
    const chunk = items.slice(i, i + itemsPerCol * 3);
    pages.push([
      chunk.slice(0, itemsPerCol),
      chunk.slice(itemsPerCol, itemsPerCol * 2),
      chunk.slice(itemsPerCol * 2, itemsPerCol * 3),
    ]);
  }
  return pages;
};

const SellNotePdfThreeColumn = ({ date, registerId, summaryData }) => {
  const summary = summaryData?.[registerId] || {};
  const flatItems = [
    ...buildFlatItems('通常販売', summary.normal || {}),
    ...buildFlatItems('免税1F', summary.tax_exempt || {}, (cat) => cat.includes('1F')),
    ...buildFlatItems('免税2F', summary.tax_exempt || {}, (cat) => cat.includes('2F')),
  ];

  const pages = chunkIntoPages(flatItems);

  return (
    <Document>
      {pages.map(([col1, col2, col3], pageIndex) => (
        <Page key={pageIndex} size="B5" style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.sectionTitle}>
              レジID: {registerId} 販売ノート {date}
            </Text>
          </View>
          <View style={styles.columns}>
            <View style={styles.column}>{col1.map(renderBlock)}</View>
            <View style={styles.column}>{col2.map(renderBlock)}</View>
            <View style={styles.column}>{col3.map(renderBlock)}</View>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default SellNotePdfThreeColumn;
